const TABLET_BREAKPOINT = 1024
const MOBILE_BREAKPOINT = 768
const RESIZE_DEBOUNCE_MS = 150

export class CustomProductsSlider extends HTMLElement {
  constructor() {
    super()
    this.handleResize = this.handleResize.bind(this)
    this.reinit = this.reinit.bind(this)
    this.currentIsMobile = null
  }

  connectedCallback() {
    this.$slider = $(this)
    this.initSlider()

    $(window).on('resize.customProductsSlider', this.handleResize)
    // Re-initialise when customising the theme in the Shopify editor
    $(window).on('shopify-custom-section-slider-event', this.reinit)
  }

  disconnectedCallback() {
    clearTimeout(this.resizeTimeout)
    $(window).off('resize.customProductsSlider', this.handleResize)
    $(window).off('shopify-custom-section-slider-event', this.reinit)
    this.destroySlider()
  }

  isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT
  }

  isTablet() {
    return window.innerWidth <= TABLET_BREAKPOINT
  }

  getSettings() {
    if (this.isMobile()) {
      return {
        arrows: false,
        dots: true,
        draggable: true,
        infinite: false,
        centerMode: false,
        slidesToShow: 1, // mobile: 1 slide (page) at a time...
        slidesToScroll: 1,
        rows: 2, // ...each page stacking 2 full-width cards
        slidesPerRow: 1,
      }
    }

    if (this.isTablet()) {
      return {
        accessibility: false,
        arrows: true,
        dots: false,
        draggable: true,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }

    return {
      accessibility: false,
      arrows: true,
      dots: false,
      draggable: true,
      infinite: false,
      slidesToShow: 4, // desktop: 4 slides at a time
      slidesToScroll: 1,
    }
  }

  destroySlider() {
    if (this.$slider && this.$slider.hasClass('slick-initialized')) {
      this.$slider.slick('unslick')
    }
  }

  initSlider() {
    if (!this.$slider) return
    this.currentIsMobile = this.isMobile()
    this.$slider.slick(this.getSettings())
  }

  // Slick's `rows`/`slidesPerRow` grouping (used on mobile) isn't reliably
  // undone by slick's own `responsive` breakpoint switching, so mobile <-> desktop
  // transitions are driven manually here: fully unslick + reinit whenever the
  // viewport crosses the mobile breakpoint, instead of trusting slick's internal
  // responsive engine to rebuild the row-grouped markup back to normal.
  handleResize() {
    clearTimeout(this.resizeTimeout)
    this.resizeTimeout = setTimeout(() => {
      const isMobile = this.isMobile()
      if (isMobile === this.currentIsMobile) return
      this.destroySlider()
      this.initSlider()
    }, RESIZE_DEBOUNCE_MS)
  }

  reinit() {
    this.destroySlider()
    this.initSlider()
  }
}
